/* eslint-disable */

import anusha from '../assets/png/projects/anusha_profile.jpg'
import sarfaraz_profile from '../assets/png/projects/sarfaraz_profile.jpg'
import yashas_profile from '../assets/png/projects/yashas_profile.jpg'




export const testimonialsData = [
    {
        id: 1,
        name: 'Sarfaraz Sheikh',
        title: 'Classmate at Masai',
        text: "Dnyaneshwar is an intelligent and deeply creative person. He's thorough and has a great eye for details. I studied and worked with him in Masai school.I was always inspired by his critical thinking and tenacity for seeing things through.",
        image: sarfaraz_profile
    },
    {
        id: 2,
        name: 'Yashas D B',
        title: 'Classmate at Masai',
        text: "I would like to recommend Dnyaneshwar because of his expertise to any person looking for a software developer. He is a profound person and his ability to tackle any problem with a warm smile is remarkable.  I studied with him and I noticed that he always make sure everyone is smiling and happy. Dnyaneshwar would become an perfect member of any team.",
        image: yashas_profile
    },
    {
        id: 2,
        name: 'Anusha Surendran',
        title: 'Classmate at Masai',
        text: "Dnyaneshwar is a disciplined, self motivated person who thrives for professionalism in his job. A nice and gentle human being by nature. He has good interpersonal, presentation and team management skill. His genuine helping nature, patience, logical thinking and problem solving skills helped everyone around a lot. He will be perfect fit in any team.",
        image: anusha
    },
    // {
    //     id: 3,
    //     name: 'Phoebe Buffay',
    //     title: 'Massuese',
    //     text: "Heard of the song 'Smelly Cat!!' ? This website made it viral. Plus portfolio is the only thing that Ursula doesn't have :)",
    //     image: girl1
    // },
    // {
    //     id: 4,
    //     name: 'Joey Tribbiani',
    //     title: 'Actor',
    //     text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
    //     image: boy1
    // },
    // {
    //     id: 5,
    //     name: 'Rachel Green',
    //     title: 'Sales Executive',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: girl3
    // },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

